// Verify mode container component - Verify Image tab
// Frontend developers can modify the visual layout here

import type { UseVerifyModeReturn } from "../hooks/useVerifyMode";
import { DropZone } from "./DropZone";
import { VerificationResult } from "./VerificationResult";
import { SimilarityResults } from "./SimilarityResults";

interface VerifyModeProps {
  verifyMode: UseVerifyModeReturn;
}

export function VerifyMode({ verifyMode }: VerifyModeProps) {
  const {
    preview,
    loading,
    loadingStatus,
    result,
    zkProofVerification,
    rawEmailVerification,
    similarMatches,
    handleFileSelect,
    handleDrop,
    handleRefresh,
    fileInputRef,
  } = verifyMode;

  return (
    <>
      {/* Drop Zone */}
      <DropZone
        preview={preview}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current?.click()}
        inputRef={fileInputRef}
        onFileSelect={handleFileSelect}
        mode="verify"
      />

      {/* Loading Status */}
      {loading && (
        <div className="verify-loading">
          <div className="progress-spinner"></div>
          <p>{loadingStatus || "Processing..."}</p>
        </div>
      )}

      {/* Verification Result */}
      {result && (
        <VerificationResult
          result={result}
          zkProofVerification={zkProofVerification}
          rawEmailVerification={rawEmailVerification}
          loading={loading}
          onRefresh={handleRefresh}
        />
      )}

      {/* Similarity Results */}
      <SimilarityResults matches={similarMatches} isLoading={loading} />
    </>
  );
}
